import clsx from "clsx";
import PropTypes from "prop-types";

import { Tooltip } from "./tooltip";

import "./text.tooltip.scss";

export const TextToolTip = ({ className, content, value }) => {
  return (
    <Tooltip className={clsx("tx-text-tooltip", className)} content={content}>
      {value}
    </Tooltip>
  );
};

TextToolTip.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node,
  value: PropTypes.string,
};
